export default {
  isCheckoutPage: false,
  loading: false,
  error: false,
  success: false,
  errorMessage: '',
  steps: ['addon', 'flights', 'travellers', 'excursions', 'passengerDetails', 'payment', 'booking'],
  stepIndex: 0,
  maxPassengers: 9,
  subtotalMismatch: false,
  quote: {
    departureId: '',
    cultureCode: '',
    currency: '',
    filo: '',
    initialTourCode: '',
    tourCode: '',
    passengers: [],
    quoteId: 0,    
    excursions: [],
    departureTransportCode: '',
    subtotal: 0,
    donationId: null,
    takeFinalBalance: false
  },
  data: {
    tourName: '',
    tourCountry: '',
    tourContinent: '',
    discount: '',
    price: '',
    addons: {
      title: 'Extend your holiday',
      descriptionHtml: '<p>Take the chance...</p>',
      bookWithoutExtensionText: 'Book without extension',
      bookExtensionText: 'Book this extension',
      dataUrl: '/umbraco/api/addon/departure'
    },
    flights: {
      title: 'Your holiday',
      descriptionHtml: '<p>You now have new flights</p>',
      dataUrl: '/umbraco/api/tourdepartures/departuredetails'
    },
    travellers: {
      title: 'Travellers',
      descriptionHtml: '<p>Travellers, Lorem ipsum greggs bacon roll dolor amet.</p>',
      introductionHtml: '<p>Please choose a room type and enter...</p>',
      roomsDataUrl: '/umbraco/api/checkoutapi/availablerooms',
      submitUrl: '/umbraco/api/checkoutapi/roomsresponse'
    },
    excursions: {
      title: 'Optional excursions',
      descriptionHtml: '<p>Excursions, Lorem ipsum greggs bacon roll dolor amet.</p>',
      bookWithoutExcursionsText: 'Book without excursions',
      dataUrl: '/umbraco/api/tourexcursion/fortour',
      submitUrl: '/umbraco/api/checkoutapi/excursionsresponse',
    },
    donations: {
      title: 'Donations',
      descriptionHtml: '<p>Donations, Lorem ipsum greggs bacon roll dolor amet.</p>',
      image: '/path/to/your/image.jpg',
      label: '<p>Please choose a donation</p>',
      dataUrl: '/umbraco/api/tourextras/getdonations',
      submitUrl: '/umbraco/api/checkoutapi/addonations'
    },
    passengerDetails: {
      title: 'Passenger details',
      descriptionHtml: '<p>Passenger details, Lorem ipsum greggs bacon roll dolor amet.</p>',
      visaDescription: 'A visa is required',
      medicalConditionWarning: '<p>You\'ve just clicked you have a medical condition, so we\'ll show this message next to the radio button</p>',
      dietaryDescription: 'You can add these later in Manage My Booking',
      termsAndConditionsLink: {
        name: 'Terms And Conditions',
        url: '/terms'
      },
      reviewText: '<p>Please review your details before continuing to pay</p>',
      reviewTextCreditCardDataAvailable: '<p>Please review your details before continuing to pay</p>',
      visaDataUrl: '/umbraco/api/checkoutapi/visas',
      submitUrl: '/umbraco/api/checkoutapi/passengerDetailsResponse',
    },
    login: {
      title: 'Login',
      descriptionHtml: '<p>Login, Lorem ipsum greggs bacon roll dolor amet.</p>'
    },
    payment: {
      title: 'Payment',
      descriptionHtml: '<p>Which amount would you like to pay towards your booking today?</p>',
      medicalWarning: 'As you\'ve told us one of your passengers has a medical conditon, we\'ll get back to you',
      generalWarning: 'Generic fallback message that you can\'t pay now',
      statusCheckUrl: '/status-check'
    },
    booking: {
      confirmBookingSubmitUrl: '/confirm-booking',
      descriptionHtml: '<p>Some description</p>',
      descriptionIfFormIsInvalid: '<p>Some description</p>',
      nextStepsTitle: 'Next Steps',
      nextStepsDescriptionHtml: '<p>Next steps...</p>',
      nextStepsLink: {
        url: '/next-steps',
        name: 'Next Steps Link'
      }
    },
    priceBreakdown: {
      subtotalMismatchHtml: '<p>Unfortunately we currently can’t display a live breakdown, however your subtotal is correct and you can still checkout. If you have any questions please call 01858 897318.</p>'
    }
  },
  addonData: {},
  departureDetails: {},
  availableRooms: [],
  rooms: [],
  excursionData: {},
  excursions: [],
  excursionsExist: false,
  excursionsVisited: false,
  visas: [],
  passengers: [],
  paymentLoading: false,
  payment: null,
  paymentFrame: null,
  cardId: '',
  bookingReference: null,
  booking: null,
  isLoginBoxDisplayed: true,
  loggedInPassengerData: null,
  nonDonatingTravellers: [],
  donationsData: {},
  loggedInPassengerData: null,
  donationPerBooking: null,
  donationMade: false,
  donations: [],
  paymentType: '',
  transactionType: '',
  tours: [],
  addons: [],
  flights: []
};
